import Button from '@/common/components/Button'
import ButtonLink from '@/common/components/ButtonLink'
import ImageWithDisplayName from '@/common/components/ImageWithDisplayName'
import { formatDateTime } from '@/common/utils/formatters'
import { maintenanceWorkflowStatus } from '@/features/maintenanceWorkflow/constants/maintenanceWorkflowsStatus.constant'
import { maintenanceForwardingsDirectiveEntryKlasses } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsDirectiveEntryKlasses.constant'
import { MaintenanceWorkflowData } from '@/features/maintenanceWorkflow/types/maintenanceWorkflows.type'
import { ArrowBigRightIcon, CarFrontIcon, UserRoundIcon } from 'lucide-react'
import { Link } from 'react-router-dom'

export class MaintenanceWorkflowsTransformer {
  static tableTransformer() {
    return (workflows: MaintenanceWorkflowData[]) => {
      return workflows.map((workflow) => {
        const directiveEntryData =
          workflow.current_forwarding &&
          maintenanceForwardingsDirectiveEntryKlasses[workflow.current_forwarding.directive_entry_type]

        return {
          status: maintenanceWorkflowStatus[workflow.status] || workflow.status,
          current_forwarding: workflow.current_forwarding ? (
            <div className="flex flex-col">
              <p>{directiveEntryData?.label || '--'}</p>

              {workflow.current_forwarding.translated_status_of_ongoing_entry && (
                <p className="text-xs italic">
                  {workflow.current_forwarding.translated_status_of_ongoing_entry}
                </p>
              )}
            </div>
          ) : (
            <p className="italic text-sm text-white-400">Pendente de Encaminhamento</p>
          ),
          establishment: workflow.current_forwarding?.establishment?.general_information?.fantasy_name || '--',
          protocol_number: (
            <div className="flex flex-col">
              <p>{workflow.protocol_number}</p>

              <p className="text-xs italic">{formatDateTime(new Date(workflow.created_at))}</p>
            </div>
          ),
          observations: workflow.observations,
          equipment: workflow.equipment?.id ? (
            <ButtonLink
              linkTo={`/equipments/${workflow.equipment.id}`}
              operationKlassToCheckPermission="Client::Equipments::Show"
            >
              <ImageWithDisplayName
                placeholderIcon={CarFrontIcon}
                imageUrl={workflow.equipment?.photos?.[0]?.url}
                displayName={workflow.equipment?.field_for_display_value}
              />
            </ButtonLink>
          ) : (
            '--'
          ),
          branch: workflow.equipment?.branch?.id ? (
            <ButtonLink
              linkTo={`/company-branches/${workflow.equipment.branch.id}`}
              operationKlassToCheckPermission="Client::CompanyBranches::Show"
            >
              {workflow.equipment?.branch?.display_name}
            </ButtonLink>
          ) : (
            '--'
          ),
          creator: workflow.creator?.id ? (
            <ButtonLink linkTo={`/users/${workflow.creator.id}`} operationKlassToCheckPermission="Client::Users::Show">
              <ImageWithDisplayName
                placeholderIcon={UserRoundIcon}
                imageUrl={workflow.creator?.profile_picture?.url}
                displayName={workflow.creator?.full_name}
              />
            </ButtonLink>
          ) : (
            '--'
          ),
          actions: (
            <Link to={workflow.id}>
              <Button
                variant="link-white"
                className="w-full"
                operationKlassToCheckPermission="Client::Maintenance::Workflows::Show"
              >
                <ArrowBigRightIcon />
              </Button>
            </Link>
          ),
        }
      })
    }
  }
}
